
<div class="search-listing-input position-relative">
    <input class="search-input-container form-control" type="text" (keyup)="onKeydown($event)" [(ngModel)]="searchValue" placeholder="Search">
    <button type="button" (click)="close()" class="btn-close position-absolute" *ngIf="showCancel"></button>
</div>
<div class="search-list-dropdown-main position-relative" *ngIf="searchArea">
    <!-- <li class="fa fa-spinner fa-spin" *ngIf="showSpinner"></li> -->
    <div class="search-list-dropdown-inner">
        <div class="loader-spinner" *ngIf="showSpinner">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
        <div *ngIf="!showSpinner" class="listing-content-main">
            <div class="listing-headings d-flex justify-content-between align-items-center px-2">
                <h3 class="order-col mb-0 font-weight-bold"><strong>Order No: </strong><span>1250256030dfdfa</span></h3>
                <h3 class="date-col mb-0 font-weight-bold"><strong>Date: </strong><span>25 Apr 2022</span></h3>
            </div>
            <div class="row listing-detais mx-0">
                <div class="col-sm-6 px-0">
                    <div class="d-inline-block listing-col list-col1">
                        <p class="d-inline-block"><label>Invoice Number :</label><span>1085afda52512552</span></p>
                        <p class="d-inline-block"><label>Address :</label><span>1085afda52512552</span></p>
                        <p class="d-inline-block"><label>Post Code :</label><span>1085afda52512552</span></p>
                    </div>
                </div>
                <div class="col-sm-6 px-0">
                    <div class="listing-col list-col2">
                        <p class="d-flex justify-content-end"><label>Customer Name :</label><span>1085afda52512552</span></p>
                        <p class="d-flex justify-content-end"><label>Phone no :</label><span>1085afda52512552</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>